import styled, {css} from 'styled-components'

export const StyledEditProfileTitle = styled.h3(
    ({theme: {typography, palette}}) => css`
        ${typography.textMd};
        color: ${palette.neutral['950']};
        font-weight: 700;
    `
)
